const EXPERIMENTS = {
  QUICK_VIEW_DRAWER: {
    CONTROL: 'quickView.footer.control',
    ALTERNATE: 'quickView.footer.alternate'
  },
  STICKY_FILTERS: {
    ENABLED: 'sticky-filters.enabled'
  },
  STICKY_MACHINE_ADD_TO_CARD: {
    V1_ENABLED: 'sticky-machine-add-to-cart.enabled',
    V2_ENABLED: 'sticky-machine-add-to-cart.v2_enabled'
  }
};

export default EXPERIMENTS;
